import { create } from "zustand";
import api from "../service/api";

export interface NesInvoiceItem {
  uuid: string;
  invoiceNumber: string;
  issueDate: string;
  totalAmount: number;
  currency: string;
  status: string;
  [key: string]: any;
}

interface EInvoiceConfig {
  provider?: string;
  username?: string;
  password?: string;
  invoiceSeries?: string;
  archiveSeries?: string;
  isActive?: boolean;
  isTestMode?: boolean;
}

interface EInvoiceStore {
  config: EInvoiceConfig | null;
  loading: boolean;
  inboundInvoices: NesInvoiceItem[];
  outboundInvoices: NesInvoiceItem[];

  fetchConfig: () => Promise<void>;
  saveConfig: (data: EInvoiceConfig) => Promise<boolean>;
  getInbound: () => Promise<NesInvoiceItem[]>;
  getOutbound: () => Promise<NesInvoiceItem[]>;
}

export const useEInvoiceStore = create<EInvoiceStore>((set) => ({
  config: null,
  loading: false,
  inboundInvoices: [],
  outboundInvoices: [],

  fetchConfig: async () => {
    set({ loading: true });
    try {
      // Varsayılan API yapısı olarak /e-invoice/config
      // Backend'deki endpointleri ayarladığınızı belirtmiştiniz.
      const res = await api.get("/e-invoice/config");
      set({ config: res.data, loading: false });
    } catch (err) {
      console.error(err);
      set({ loading: false });
    }
  },

  saveConfig: async (data: EInvoiceConfig) => {
    set({ loading: true });
    try {
      await api.post("/e-invoice/config", data);
      set({ config: data, loading: false });
      return true;
    } catch (err) {
      console.error(err);
      set({ loading: false });
      return false;
    }
  },

  getInbound: async () => {
    set({ loading: true });
    try {
      const res = await api.get("/e-invoice/inbound");
      const items = res.data?.items || res.data || [];
      set({ inboundInvoices: items, loading: false });
      return items;
    } catch (err) {
      console.error(err);
      set({ loading: false });
      return [];
    }
  },

  getOutbound: async () => {
    set({ loading: true });
    try {
      const res = await api.get("/e-invoice/outbound");
      const items = res.data?.items || res.data || [];
      set({ outboundInvoices: items, loading: false });
      return items;
    } catch (err) {
      console.error(err);
      set({ loading: false });
      return [];
    }
  }
}));
